<template>

    <v-modal title="Create Trait">
        <template #body>
            <v-alert :message="error" />
            <form @submit.prevent="createTrait">
                <v-form-group dir="ver" label="Name">
                    <v-input placeholder="My Trait Name" :model="params.name" @input="params.name = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createTrait">Create Trait</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        createTrait() {
            this.loading = true;
            ProjectApi.createTrait(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('created');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
